import { render } from "./RefcodeTool.vue?vue&type=template&id=1f574d62"
import script from "./RefcodeTool.vue?vue&type=script&lang=js"
export * from "./RefcodeTool.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/momentum-generator/momentum-generator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__